/// <reference types="./comment.d.mts" />
import * as $timestamp_ from "../../common_common/gleam/time/timestamp/extra.mjs";
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $timestamp from "../../gleam_time/gleam/time/timestamp.mjs";
import * as $decrypt from "../decrypt.mjs";
import { toList, CustomType as $CustomType } from "../gleam.mjs";

export class EditionPayload extends $CustomType {
  constructor(value, comment_id) {
    super();
    this.value = value;
    this.comment_id = comment_id;
  }
}

export class CommentHistory extends $CustomType {
  constructor(value, created_at) {
    super();
    this.value = value;
    this.created_at = created_at;
  }
}

export class React extends $CustomType {
  constructor(value, owner) {
    super();
    this.value = value;
    this.owner = owner;
  }
}

export class Comment extends $CustomType {
  constructor(id, owner, value, org_id, target_id, is_resolved, is_deleted, reacts, history, mentions, updated_at, created_at) {
    super();
    this.id = id;
    this.owner = owner;
    this.value = value;
    this.org_id = org_id;
    this.target_id = target_id;
    this.is_resolved = is_resolved;
    this.is_deleted = is_deleted;
    this.reacts = reacts;
    this.history = history;
    this.mentions = mentions;
    this.updated_at = updated_at;
    this.created_at = created_at;
  }
}

export function edition_payload_decoder() {
  return $decode.field(
    "comment_id",
    $decrypt.uuid(),
    (comment_id) => {
      return $decode.field(
        "value",
        $decode.string,
        (value) => {
          return $decode.success(new EditionPayload(value, comment_id));
        },
      );
    },
  );
}

export function react_decoder() {
  return $decode.field(
    "owner",
    $decode.string,
    (owner) => {
      return $decode.field(
        "value",
        $decode.string,
        (value) => { return $decode.success(new React(value, owner)); },
      );
    },
  );
}

export function history_decoder() {
  return $decode.field(
    "value",
    $decode.string,
    (value) => {
      return $decode.field(
        "created_at",
        $decrypt.timestamp(),
        (created_at) => {
          return $decode.success(new CommentHistory(value, created_at));
        },
      );
    },
  );
}

export function decoder() {
  return $decode.field(
    "id",
    $decrypt.uuid(),
    (id) => {
      return $decode.field(
        "owner",
        $decode.string,
        (owner) => {
          return $decode.field(
            "value",
            $decode.string,
            (value) => {
              return $decode.field(
                "org_id",
                $decode.string,
                (org_id) => {
                  return $decode.field(
                    "target_id",
                    $decrypt.uuid(),
                    (target_id) => {
                      return $decode.field(
                        "is_resolved",
                        $decode.bool,
                        (is_resolved) => {
                          return $decode.field(
                            "is_deleted",
                            $decode.bool,
                            (is_deleted) => {
                              return $decode.field(
                                "reacts",
                                $decrypt.json($decode.list(react_decoder())),
                                (reacts) => {
                                  return $decode.field(
                                    "history",
                                    $decrypt.json(
                                      $decode.list(history_decoder()),
                                    ),
                                    (history) => {
                                      return $decode.field(
                                        "created_at",
                                        $decrypt.timestamp(),
                                        (created_at) => {
                                          return $decode.field(
                                            "updated_at",
                                            $decrypt.timestamp(),
                                            (updated_at) => {
                                              return $decode.field(
                                                "mentions",
                                                $decrypt.json(
                                                  $decode.list($decode.string),
                                                ),
                                                (mentions) => {
                                                  return $decode.success(
                                                    new Comment(
                                                      id,
                                                      owner,
                                                      value,
                                                      org_id,
                                                      target_id,
                                                      is_resolved,
                                                      is_deleted,
                                                      reacts,
                                                      history,
                                                      mentions,
                                                      updated_at,
                                                      created_at,
                                                    ),
                                                  );
                                                },
                                              );
                                            },
                                          );
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function react_encoder(react) {
  return $json.object(
    toList([
      ["value", $json.string(react.value)],
      ["owner", $json.string(react.owner)],
    ]),
  );
}

export function comment_history_encoder(history) {
  return $json.object(
    toList([
      ["value", $json.string(history.value)],
      ["created_at", $timestamp_.encode(history.created_at)],
    ]),
  );
}

export function encoder(comment) {
  return $json.object(
    toList([
      ["id", $json.string(comment.id)],
      ["owner", $json.string(comment.owner)],
      ["value", $json.string(comment.value)],
      ["org_id", $json.string(comment.org_id)],
      ["target_id", $json.string(comment.target_id)],
      ["is_resolved", $json.bool(comment.is_resolved)],
      ["is_deleted", $json.bool(comment.is_deleted)],
      ["history", $json.array(comment.history, comment_history_encoder)],
      ["reacts", $json.array(comment.reacts, react_encoder)],
      ["mentions", $json.array(comment.mentions, $json.string)],
      ["created_at", $timestamp_.encode(comment.created_at)],
      ["updated_at", $timestamp_.encode(comment.updated_at)],
    ]),
  );
}

export function edition_payload_encoder(payload) {
  return $json.object(
    toList([
      ["value", $json.string(payload.value)],
      ["comment_id", $json.string(payload.comment_id)],
    ]),
  );
}

export function sort_by_creation_date(comments) {
  return $list.sort(
    comments,
    (c1, c2) => { return $timestamp.compare(c1.created_at, c2.created_at); },
  );
}
